import { createContext, useEffect, useState } from "react";
import { Api } from "../services/Api";
import PropTypes from "prop-types";

export const FeatureFlagContext = createContext();

const FeatureFlagProviderProps = {
   children: PropTypes.node,
};

export const FeatureFlagProvider = ({ children }) => {
   const api = new Api();
   api.setup();

   const [flags, setFlags] = useState({});
   const [loading, setLoading] = useState(true);

   useEffect(() => {
      (async () => {
         await api
            .getFeatureFlags()
            .then(response => response?.data?.responseList)
            .then(data => {
               setFlags(data);
               setLoading(false);
            });
      })();
   }, []);

   if (!loading) {
      return <FeatureFlagContext.Provider value={flags}>{children}</FeatureFlagContext.Provider>;
   }
};

FeatureFlagProvider.propTypes = FeatureFlagProviderProps;
